import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Box, Stack, Typography, Button, Icon } from '@mui/material';
import { Book } from '@mui/icons-material'
const RelatedMenu = ({ links = [], children }) => {
  const navigate = useNavigate();

  return (
    <Paper variant='section' sx={{ background: 'linear-gradient(135deg, #E2F2FF 0%, #DEDFF4 100%)' }}>
      {/* ヘッダー */}
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Book color="primary" />
        <Typography component="h2" variant="h4">関連メニュー</Typography>
      </Stack>
      {/* メニュー部分：2カラムグリッド */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 1,
        }}
      >
        {links.map((link, index) => (
          <Button
            key={index}
            variant="related-menu"
            onClick={() => navigate(link.path)}
          >
            <Icon style={{ fontSize: 30 }}>{link.icon}</Icon>
            {link.label}
          </Button>
        ))}
        {/* children があれば同じグリッドに追加 */}
        {children && React.Children.map(children, (child) => (
          <>{child}</>
        ))}
      </Box>
    </Paper>

  );
};

export default RelatedMenu;
